





















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Request from "@/models/checkRequest/request";
import RequestService from "@/services/requestService";

@Component
export default class ListItem extends Vue {
  @Prop({ required: true })
  request!: Request;

  @Prop({ default: false })
  active!: boolean;

  get statusCode(): number {
    return RequestService.GetFirstStatusCode(this.request);
  }
}
